import type { Clock } from '@/application/ports/Clock';

/**
 * Section 9, clock drift. Shared floor devices drift, sometimes by minutes. On
 * every session read the offset between the server time and this device is
 * recorded, and every timestamp the client stamps afterwards is corrected by it.
 *
 * Getting this wrong shows up as a technician's active time being negative, or
 * as a case that was started tomorrow.
 */
export class SystemClock implements Clock {
  private offsetMs = 0;

  now(): Date {
    return new Date(Date.now() + this.offsetMs);
  }

  syncTo(serverTime: string): void {
    const server = new Date(serverTime).getTime();
    if (Number.isNaN(server)) return;
    this.offsetMs = server - Date.now();
  }

  driftMs(): number {
    return this.offsetMs;
  }
}
